import { AxiosError } from 'axios';
import { FileConfig } from 'web-library';
import { GET_PROFILE_AMENDMENT_REQUEST_FILE_CONFIGS_URL } from '../../constants/apiUrls';
import { GET_PROFILE_AMENDMENT_REQUEST_FILE_CONFIGS_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request / Response
// =============================================================================
interface Input {
  onSuccess?: (res: FileConfig) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

// =============================================================================
// Query
// =============================================================================

export const useGetProfileAmendmentRequestFileConfigs = ({ onError, onSuccess }: Input = {}) => {
  const getProfileAmendmentRequestFileConfigs = async () => {
    const res = await axiosClient.get<FileConfig>(GET_PROFILE_AMENDMENT_REQUEST_FILE_CONFIGS_URL);
    return res.data;
  };

  return useCustomQuery(
    GET_PROFILE_AMENDMENT_REQUEST_FILE_CONFIGS_QUERY_KEY,
    getProfileAmendmentRequestFileConfigs,
    {
      onSuccess,
      onError,
    }
  );
};
